import { Controller } from "@hotwired/stimulus"

const CLOSED_CLASSES = ["w-0", "opacity-0"]
const OPEN_CLASSES = ["w-full", "md:w-[560px]", "opacity-100"]

export default class extends Controller {
  static targets = ["panel"]

  // The preview frame's content arrives via frame navigation and via turbo_stream.replace
  // (shared partials from the legacy process-documents page). Stream replaces fire no
  // turbo:frame-load and swap out the frame element itself, so watch the panel's subtree.
  connect() {
    this.observer = new MutationObserver(() => this.syncVisibility())
    this.observer.observe(this.panelTarget, { childList: true, subtree: true })
  }

  syncVisibility() {
    const wasReset = this.panelTarget.querySelector("[data-panel-reset]") != null
    if (wasReset) {
      this.hide()
    } else {
      this.show()
      this.focusPanelContent()
    }
  }

  disconnect() {
    this.observer?.disconnect()
  }

  show(event) {
    if (event?.currentTarget) {
      this.opener = event.currentTarget
      this.focusPending = true
    }
    this.panelTarget.inert = false
    this.panelTarget.classList.remove(...CLOSED_CLASSES)
    this.panelTarget.classList.add(...OPEN_CLASSES)

    this.panelTarget.scrollIntoView({ behavior: "smooth", block: "nearest" })
  }

  hide() {
    const focusWasInside = this.panelTarget.contains(document.activeElement)
    this.panelTarget.inert = true
    this.panelTarget.classList.remove(...OPEN_CLASSES)
    this.panelTarget.classList.add(...CLOSED_CLASSES)
    this.focusPending = false

    if (focusWasInside && this.opener?.isConnected) this.opener.focus()
  }

  focusPanelContent() {
    if (!this.focusPending) return

    const heading = this.panelTarget.querySelector("h1, h2, h3")
    if (!heading) return

    this.focusPending = false
    heading.tabIndex = -1
    heading.focus({ preventScroll: true })
  }
}
